// @flow
import React, { useCallback } from 'react';
import type { Node } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import TextField from '../../../../common/components/text-field';
import { ACTION_TEXT_FIELD_ON_CHANGE } from '../../form-submitter-context/form-submitter-constant';
import { useFormSubmitterContext } from '../../form-submitter-context';
import RequiredMark from '../../../../common/components/required-mark';
import {
  ELEMENT_EMAIL_ID,
  ELEMENT_DESCRIPTION_ID,
  EMAIL_FIELD_LIMIT,
  FILE_DESCRIPTION_FIELD_LIMIT,
  LONG_TEXT_FIELD_LIMIT,
} from '../../../../constants';

import type { TextFieldElement } from '../../../../types/form/Element';

type Props = {
  description?: Node,
  element: TextFieldElement,
};

const TextFieldWithContext = (props: Props) => {
  const { element, description } = props;
  const { id, label, required, multiline, textType, visible } = element;
  const {
    state,
    dispatch,
    selector: { getTextValueForId, getErrorForId },
  } = useFormSubmitterContext();

  let limit;
  if (id === ELEMENT_EMAIL_ID) {
    limit = EMAIL_FIELD_LIMIT;
  } else if (id === ELEMENT_DESCRIPTION_ID) {
    limit = FILE_DESCRIPTION_FIELD_LIMIT;
  } else if (multiline) {
    limit = LONG_TEXT_FIELD_LIMIT;
  }

  const value = getTextValueForId(state, id);
  const error = getErrorForId(state, id);
  const { submitInProgress } = state;
  const isDisabled = submitInProgress;
  const onChange = useCallback(
    newValue => {
      dispatch({
        id,
        type: ACTION_TEXT_FIELD_ON_CHANGE,
        newValue,
      });
    },
    [dispatch, id],
  );

  const renderLabel = required ? (
    <>
      {label} <RequiredMark />
    </>
  ) : (
    label
  );

  return visible !== false ? (
    <TextField
      description={description}
      error={error && <FormattedMessage {...error} />}
      isDisabled={isDisabled}
      isMultiLine={multiline}
      isRequired={required}
      label={renderLabel}
      limit={limit}
      onChange={onChange}
      type={textType}
      value={value}
    />
  ) : null;
};

export { TextFieldWithContext };
export default injectIntl(TextFieldWithContext);
